const getTranslationsQuery = (type: string, language: string) => {
  const country = window.Shopify?.country;

  if (!country) {
    throw new Error('window.Shopify.country is required for GraphQL query');
  }

  if (!language) {
    throw new Error('Language parameter is required for GraphQL query');
  }

  return `
  query getTranslationsMetaobject @inContext(country: ${country}, language: ${language}) {
   metaobjects(first: 1,type: "${type}") {
        edges {
            node {
                id
                fields {
                    key
                    value
                }
            }
        }
    }
}`;
};

export default getTranslationsQuery;
